// ============================================================================
// DFS - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'dfs',
  name: 'DFS',
  category: 'Graphs',
  complexity: {
    time: 'O(V + E)',
    space: 'O(V)'
  },
  description: 'Depth-First Search is a graph traversal algorithm that explores as far as possible along each branch before backtracking. It uses a stack (either explicitly or via recursion) and is used for topological sorting, cycle detection, and pathfinding.'
};
